import dayjs, { ConfigType } from 'dayjs';
import { DurationUnitType } from 'dayjs/plugin/duration';

export const formatTimezoneSpecific = (
  date: ConfigType,
  timeZone?: string,
  template: string = 'L'
): string => {
  const isStringNumber = typeof date === 'string' && /^\d+$/.test(date);
  const dayjsValue = dayjs(isStringNumber ? Number(date) : date);

  return (timeZone ? dayjsValue.tz(timeZone) : dayjsValue).format(template);
};

export const getDuration = (
  start: number | dayjs.Dayjs,
  unit: DurationUnitType = 'second',
  finished?: number | dayjs.Dayjs
): number => {
  const startDate = dayjs(start);

  if (!finished) {
    return dayjs.duration(dayjs().diff(startDate)).as(unit);
  }

  const finishDate = dayjs(finished);
  const diff = finishDate.diff(dayjs());
  const durationValue = dayjs.duration(Math.max(diff, 0));

  return Math.floor(durationValue.as(unit));
};
